import ExpandToggler from './components/ExpandToggler';
import Util from './util/Util';

const expanderConfig = {
  toggleSelector: '.facetFilter__toggle',
  targetSelector: '.facetFilter__optionsWrap',
  parentSelector: '.facetFilter',
  parentExpandedClass: 'facetFilter--open',
  onToggle: ensureFacetDropdownsOnScreen
};

let listingForm;

function init() {
  listingForm = document.querySelector('.eventListing__filterForm');
  
  if (!listingForm) { return; }
  
  ExpandToggler.init(expanderConfig);
  initCloseButtons();
  
  // Any clicks outside of an open facet closes the facet.
  document.body.addEventListener('click', e => {
    document.querySelectorAll('.facetFilter--open').forEach(openFacet => {
      if (!openFacet.contains(e.target)) {
        openFacet.querySelector('.facetFilter__toggle').ExpandToggler.setExpanded(false);
      }
    });
  });
  
  window.addEventListener('resize', ensureFacetDropdownsOnScreen);
}

function initCloseButtons() {
  document.querySelectorAll('.facetTag__close').forEach(button => {
    button.addEventListener('click', e => {
      const name = button.dataset.name;
      const value = button.dataset.value;
      const checkboxSelector = `.facetFilter input[value='${ value }'][name='${ name }[]']`;
      const checkbox = document.querySelector(checkboxSelector);
      
      checkbox && (checkbox.checked = false);
      listingForm.submit();
    });
  });
}

function ensureFacetDropdownsOnScreen() {
  const bufferSpacing = 12;
  const rightEdge = window.innerWidth - bufferSpacing;

  document.querySelectorAll('.facetFilter--open').forEach(openFacet => {
    const options = openFacet.querySelector('.facetFilter__options');
    const optionsWrap = openFacet.querySelector('.facetFilter__optionsWrap');
    
    optionsWrap.style.left = null;
    options.style.gridTemplateColumns = null;
    Util.forceReflow(optionsWrap);
    
    const rect = options.getBoundingClientRect();

    // Not off the right side?  We're good, return.
    if (rect.right < rightEdge) {
      return;
    }
    
    // Off the right side?  Shift it left enough to remain on the screen
    const adjustLeft = rightEdge - rect.right;
    
    // Make sure we're still on the screen after the adjustment
    // If so, make the adjustment, and we're done
    if (rect.left + adjustLeft > 0) {
      optionsWrap.style.left = adjustLeft + 'px';
      return;
    }
    
    // Okay, so now we're pushing the left side of the screen as well?  Allow options to wrap.
    // Options are already limited to a width of (100vw - 20px), so we shouldn't see any further issues.
    options.style.gridTemplateColumns = 'auto auto auto';
  });
}

export default { init };